import React from "react";
import { NavLink } from "react-router-dom";
import { Navbar, Nav, NavDropdown } from "react-bootstrap";
import * as Icon from "react-feather";
import "./SideMenu.css";

class SideMenuLight extends React.Component {
  render() {
    return (
      <div
        className={`sidemenu-area sidemenu-light ${
          this.props.sideMenu ? "sidemenu-toggle" : ""
        }`}
      >
        <Navbar
          className={`sidemenu ${this.props.sideMenu ? "hide-nav-title" : ""}`}
        >
          <Navbar.Collapse>
            <Nav>
              <NavLink to="/dashboard/" className="nav-link">
                <Icon.Grid className="icon" />
                <span className="title">Dashboard</span>
              </NavLink>

              <NavLink to="/barbershops/" className="nav-link">
                <Icon.Scissors className="icon" />
                <span className="title">Barbershops</span>
              </NavLink>
              <NavLink to="/referrals/" className="nav-link">
                <Icon.MessageCircle className="icon" />
                <span className="title">Referrals</span>
              </NavLink>
            </Nav>
          </Navbar.Collapse>
        </Navbar>
      </div>
    );
  }
}

export default SideMenuLight;
